define.alias("ember-focus-trap/modifiers/focus-trap.js", "settings/modifiers/focus-trap");